import * as React from 'react'
import { useLocale } from 'use-intl'
import { resolveImplementedLocale } from '~/lib/i18n/shared'
import { Footer } from './footer'
import { Header } from './header'

export function PublicLayout({ children }: { children: React.ReactNode }) {
  const locale = resolveImplementedLocale(useLocale())
  const skipLabel = locale === 'zh-CN' ? '跳到主要内容' : 'Skip to main content'

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <a
        href="#main-content"
        className="fixed left-4 top-4 z-50 inline-flex min-h-11 -translate-y-20 items-center rounded-xl bg-foreground px-4 text-sm font-bold text-background shadow-lg transition-transform focus:translate-y-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
      >
        {skipLabel}
      </a>
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  )
}
